import { Autocomplete, AutocompleteProps, createFilterOptions, TextField } from '@mui/material';
import { Controller, FieldError } from 'react-hook-form';

interface Props<T, Multiple extends boolean | undefined, FreeSolo extends boolean | undefined>
    extends Omit<AutocompleteProps<T, Multiple, undefined, FreeSolo>, 'renderInput'> {
    name: string;
    label?: string;
    placeholder?: string;
    defaultValue: any;
    minWidth?: number;
}

export function ControlledAutocomplete<
    T,
    Multiple extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined,
>({ name, label, placeholder, defaultValue, minWidth = 227, ...props }: Props<T, Multiple, FreeSolo>) {
    return (
        <Controller
            name={name}
            defaultValue={defaultValue}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Autocomplete
                    {...props}
                    id={`${name}-field`}
                    sx={{
                        minWidth: minWidth,
                        '.MuiInputBase-root': {
                            height: 'auto',
                        },
                    }}
                    autoComplete={false}
                    onChange={(_, data) => onChange(data)}
                    value={value}
                    filterOptions={createFilterOptions({
                        ignoreCase: true,
                    })}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            placeholder={placeholder}
                            slotProps={{
                                inputLabel: { ...params.InputLabelProps, shrink: true },
                            }}
                            error={!!error}
                            helperText={
                                error
                                    ? props.multiple
                                        ? (error as unknown as FieldError[])[0]?.message
                                        : error.message
                                    : null
                            }
                        />
                    )}
                />
            )}
        />
    );
}
